import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Comments from './Comments';
import './BlogPost.css';

const BlogPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      // Use the same API URL pattern as all other components in the codebase
      const apiUrl = process.env.REACT_APP_API_URL || 'https://jakakaomajka.com/backend';
      
      try {
        console.log(`Fetching post from: ${apiUrl}/api/posts/${id}`);
        const response = await axios.get(`${apiUrl}/api/posts/${id}`, {
          timeout: 10000,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        
        // Check if response is HTML (indicates routing issue)
        if (typeof response.data === 'string' && response.data.includes('<!doctype html>')) {
          console.log(`${apiUrl} returned HTML instead of JSON - backend not running or misconfigured`);
          setError('Backend service is not running. Please contact the administrator.');
          setIsLoading(false);
          return;
        }
        
        // Validate that we got a proper post object
        if (response.data && response.data._id) {
          console.log(`✅ SUCCESS: Post loaded successfully!`);
          setPost(response.data);
          setIsLoading(false);
        } else {
          console.log(`Invalid post data received`);
          setError('Post not found.');
          setIsLoading(false);
        }
        
      } catch (error) {
        console.error(`❌ FAILED to fetch post:`, error);
        
        if (error.code === 'ECONNREFUSED' || error.message.includes('Network Error')) {
          setError('Cannot connect to the server. The backend service may be down.');
        } else if (error.response && error.response.status === 404) {
          setError('Post not found.');
        } else if (error.message.includes('timeout')) {
          setError('Server is taking too long to respond. Please try again later.');
        } else {
          setError('Unable to load post. Please try again later.');
        }
        
        setIsLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  if (isLoading) return <div className="loading">Loading post...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!post) return <div className="error">Post not found</div>;

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return 'Datum nije dostupan';
      }
      return date.toLocaleDateString('sr-RS');
    } catch (error) {
      return 'Datum nije dostupan';
    }
  };

  let featuredImageUrl = post.featuredImage;
  // Handle relative URLs by trying multiple possible base paths
  if (!featuredImageUrl.startsWith('http')) {
    const possiblePaths = [
      `https://jakakaomajka.com/uploads/${featuredImageUrl}`,
      `https://jakakaomajka.com/backend/uploads/${featuredImageUrl}`,
      `https://jakakaomajka.com/${featuredImageUrl}`,
      `https://jakakaomajka.com/backend/${featuredImageUrl}`
    ];
    // Log each attempt for debugging
    console.log('Trying image paths:', possiblePaths);
    featuredImageUrl = possiblePaths[0]; // Start with the first path
    // You could implement logic to try each path in sequence on error, but for simplicity, we use the first for now
  }

  return (
    <div className="blog-post">
      <article>
        <h1>{post.title || 'Naslov nije dostupan'}</h1>
        <div className="post-meta">
          <span className="post-date">{formatDate(post.createdAt)}</span>
          {post.categoryId && (
            <span className="post-category"> • {post.categoryId}</span>
          )}
        </div>
        {post.featuredImage && (
          <div className="featured-image">
            <img 
              src={featuredImageUrl}
              alt={post.title} 
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}
        <div className="post-content" dangerouslySetInnerHTML={{ __html: post.content || '<p>Sadržaj članka nije dostupan.</p>' }} />
      </article>

      <Comments postId={id} />
    </div>
  );
};

export default BlogPost; 